module.exports = __webpack_public_path__ + "assets/img/CustomHeader.2a41665b.png";